<template>
    <!-- 检测记录-查看报告-修改图片-检测详情 -->
    <el-dialog
        title="检测详情"
        :visible.sync="dialogVisible1"
        width="640px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        append-to-body
        :before-close="handleClose"
        top="8vh"
    >
        <div
            v-loading="loading"
            class="check-detail-container"
            element-loading-text="拼命加载中"
            element-loading-background="rgba(255,255,255,0)"
        >
            <div class="tabs-head dfc">
                <p v-if="detail.word !== '无检测出违禁词'" :class="{ active: showText === 0 }" @click="changeTab(0)">
                    违禁词
                </p>
                <!-- <p
          @click="changeTab(1)"
          :class="{ active: showText === 1 }"
          v-if="detail.fontJudge === '是'"
        >
          方正字体
        </p> -->
                <p class="empty">
                    <span
                        ><em class="red">*</em
                        >{{ showText === 0 ? '“红色字体”为已检测出的违禁词' : '“红色字体”疑似为方正字体' }}</span
                    >
                </p>
            </div>
            <div class="tabs-body mt25">
                <a
                    :href="detail.path"
                    class="detail-img"
                    target="_blank"
                    :style="{
                        backgroundImage: `url(${
                            detail.path ? detail.path : 'http://oss.fjdaze.com/aliProject/images/no_image100x100.jpg'
                        })`,
                    }"
                ></a>
                <div v-show="showText === 0" class="detail-word-content" v-html="detail.allWord"></div>
                <div v-show="showText === 1" class="detail-font-content" v-html="detail.allFont"></div>
                <!-- <div class="detail-tip" v-if="showTip">
          <span>点击红色字体可查看疑似字体对比效果</span><em @click.stop="hideTip">x</em>
        </div> -->
            </div>
        </div>
        <el-dialog
            title="风险内容"
            :visible.sync="dialogVisible2"
            width="960px"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            top="8vh"
        >
            <div class="dangerous-content-container">
                <p class="ml30">
                    *第一行为原图内容，其余为检测结果，分值高于0.6为高度疑似，请审慎发布。
                    <font class="curp" style="color: #0064c1" @click="dialogVisible3 = true">查看示例</font>
                </p>
                <div v-if="resultList.length" class="dangerous-content mt40 dfcjc">
                    <i
                        v-show="currentIndex !== 0"
                        class="iconfont-npm icon-npm-jiantou1 left-arrow"
                        @click="currentIndex--"
                    ></i>
                    <div class="ml10 mr10" style="width: 860px; overflow: auto">
                        <img :src="resultList[currentIndex].compared_Image" alt="" @click="imgClick" />
                    </div>
                    <i
                        v-show="currentIndex !== resultList.length - 1"
                        class="iconfont-npm icon-npm-jiantou right-arrow"
                        @click="currentIndex++"
                    ></i>
                </div>
            </div>
        </el-dialog>
        <!-- <el-dialog
      title="方正字体检测结果示例"
      :visible.sync="dialogVisible3"
      width="900px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      top="8vh"
    >
      <img
        src="@business/assets/images/forbiddenWord/sample.jpg"
        alt=""
        style="width: 860px;height: 440px;"
      />
    </el-dialog> -->
    </el-dialog>
</template>
<script>
import { cloneDeep } from 'lodash';
export default {
    name: 'CheckDetail',
    data() {
        return {
            dialogVisible1: false,
            dialogVisible2: false,
            dialogVisible3: false,
            loading: false,
            detail: {},
            resultList: [],
            showText: 0,
            currentIndex: 0, // 默认显示图片
            // showTip: true,
        };
    },
    // created() {
    //   let flag = localStorage.getItem("DialogTitle");
    //   if (flag) {
    //     this.showTip = false;
    //   }
    // },
    methods: {
        show(data) {
            this.showText = 0;
            this.detail = cloneDeep(data);
            this.dialogVisible1 = true;
            this.$nextTick(() => {
                // this.registerEvent(); // 要显示方正字体再取消注释
            });
        },
        changeTab(index) {
            if (this.showText === index) {
                //
            } else {
                this.showText = index;
            }
        },
        // hideTip() {
        //   localStorage.setItem("DialogTitle", JSON.stringify({ key: "20210326" }));
        //   this.showTip = false;
        // },
        registerEvent(isDestroy = false) {
            const dom = document.querySelector('.detail-font-content');
            if (isDestroy) {
                // 移除事件
                dom.removeEventListener('click', this.event, false);
            } else {
                dom.addEventListener('click', this.event, false);
            }
        },
        event(e) {
            if (e.target.outerHTML.indexOf('<em') > -1) {
                const path = this.detail.path;
                this.loading = true;
                this.$ajax.post('app/api/to/getfwcompareimg', { imgUrl: path }).then((res) => {
                    this.loading = false;
                    if (!res.code == 200) {
                        this.$message.warning(res.msg);
                        return;
                    }
                    const arr = [];
                    for (var i = 0; i < res.result.content.length; i++) {
                        if (res.result.content[i].font == 'founder') {
                            arr.push(res.result.content[i]);
                        }
                    }
                    this.resultList = arr;
                    this.dialogVisible2 = true;
                });
            }
        },
        imgClick() {
            const img = new Image();
            img.src = this.resultList[this.currentIndex].compared_Image;
            const newTab = window.open('', '_blank');
            newTab.document.write(img.outerHTML);
            newTab.document.title = '流程图';
            newTab.document.close();
        },
        handleClose(done) {
            // this.registerEvent(true);
            done();
        },
    },
};
</script>
<style lang="scss">
.check-detail-container {
    color: #666;
    font-size: 14px;
    line-height: 1.5;
    .red {
        color: #e91b00;
    }
    .tabs-head {
        p {
            width: 100px;
            height: 36px;
            float: left;
            line-height: 36px;
            text-align: center;
            border: 1px solid #ddd;
            position: relative;
            top: 0;
            background: #fff;
            color: #000;
            cursor: pointer;
            & + p {
                border-left: none;
            }
            &.active {
                border-bottom: none;
                color: #0f7bea;
            }
            i {
                width: 25px;
                height: 25px;
                line-height: 25px;
                text-align: center;
                background-color: #fc214a;
                display: inline-block;
                border-radius: 50%;
                color: #fff;
                position: absolute;
                top: -16px;
                right: 3px;
                font-size: 12px;
            }
            &.empty {
                flex: 1;
                border-top: none;
                border-right: none;
                cursor: default;
                text-align: right;
                color: #999999;
            }
        }
    }
    .tabs-body {
        position: relative;
        display: flex;
        justify-content: space-between;
        .detail-img {
            width: 300px;
            height: 300px;
            display: block;
            background-position: center center;
            background-repeat: no-repeat;
            background-size: contain;
            background-color: #fff;
            border: 1px solid #eeeeee;
        }
        .detail-word-content,
        .detail-font-content {
            width: 300px;
            max-height: 300px;
            padding: 20px;
            position: relative;
            overflow-x: hidden;
        }
        .detail-font-content {
            em {
                cursor: pointer;
            }
        }
        .detail-tip {
            width: 245px;
            height: 65px;
            background: #ffffcc;
            position: absolute;
            top: 0;
            right: 7px;
            color: #1e1e1e;
            padding: 10px;
            font-weight: bold;
            cursor: pointer;
            em {
                position: absolute;
                top: 0;
                right: 0;
            }
        }
    }
}
.dangerous-content-container {
    color: #666;
    font-size: 14px;
    line-height: 1.5;
    height: 400px;
    .dangerous-content {
        position: relative;
        i {
            position: absolute;
            top: 50%;
            font-size: 20px;
            cursor: pointer;
        }
        .left-arrow {
            left: 0;
        }
        .right-arrow {
            right: 0;
        }
        img {
            font-size: 0;
        }
    }
}
</style>
